import React from 'react'

import { ListBadgeStyled, ListBadgeInnerStyled } from './ListBadge.styles'

export const ListBadge: React.FC<{
  color: string
  children?: React.ReactNode
  prefix?: string
}> = ({ color, prefix, children }) => (
  <ListBadgeStyled color={color}>
    <ListBadgeInnerStyled prefix={prefix || ''}>{children}</ListBadgeInnerStyled>
  </ListBadgeStyled>
)
